import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import T from '../../../../SPRINTA/translate/T'
import { Container, Row, Col } from '../../../atoms/Grid'

import PlaceHolder from '../../../atoms/PlaceHolder'
import ListScroll, { Item as ListItem } from '../../../molecules/ListScroll'
import { numberFormat } from '../../../../libraries/Formatter'

import style from './style.css'

export default class ListPrices extends Component {
    static propTypes = {
        token: PropTypes.string.isRequired
    }

    state = {
        prices: null
    }

    componentWillMount() {
        axios.get(`events/prices/${this.props.token}`)
        .then(resp => {
            this.setState({
                prices: resp
            })
        })
    }

    render() {
        if(this.state.prices !== null && this.state.prices.length === 0) return <span />
        
        return (
            
            <div className={style.bgGrey}>
                <Container>
                    <Row>
                        <Col size={8}>
        
                            { this.state.prices === null && (
                                <div>
                                    <PlaceHolder type='retangle'/>
                                    <PlaceHolder type='retangle'/>
                                    <PlaceHolder type='retangle'/>
                                </div>
                            )}

                            { this.state.prices !== null && (
                                <div>
                                    <div className={style.title}>{T.text('prices')}</div>                      

                                    <ListScroll color='white'>
                                        { this.state.prices.map(price => (
                                            <ListItem key={price.id}>
                                                <span style={{textTransform: 'uppercase'}}>{price.description}</span>
                                                <span className={style.price}>R$ {numberFormat(price.current_price, 2, ',', '.')}</span>
                                            </ListItem>
                                        )) }
                                    </ListScroll>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/templates/Event/ListPrices/index.js